import { AutogenModelHandlingRequirement, AutogenRowHandlingRequirement } from "./autogen/AutogenModelHandlingRequirement";

export class ModelHandlingRequirement extends AutogenModelHandlingRequirement<RowHandlingRequirement> {
    constructor() {
        super(RowHandlingRequirement);
    }
}

export class RowHandlingRequirement extends AutogenRowHandlingRequirement {
}